export default "/build/dist/0e69c43f31225c32.js"